/* Kiomia - pagina prodotto: galleria, fisarmoniche, quantita, varianti, ricariche,
   confronto prima/dopo trascinabile e barra d'acquisto fissa.
   Tutto idempotente e sicuro al re-render del Theme Editor. */
(function(){
  function uno(sel, ctx){ return (ctx || document).querySelector(sel); }
  function tutti(sel, ctx){ return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function radice(){ return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  /* Galleria: miniature che cambiano lo scatto grande. */
  function galleria(root){
    tutti('[data-km-gal]:not([data-km-ready])', root).forEach(function(g){
      g.setAttribute('data-km-ready','1');
      var slides = tutti('[data-km-slide]', g);
      var thumbs = tutti('[data-km-thumb]', g);
      function vai(i){
        slides.forEach(function(s,k){ s.classList.toggle('is-on', k === i); });
        thumbs.forEach(function(t,k){ t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      }
      thumbs.forEach(function(t,k){ t.addEventListener('click', function(){ vai(k); }); });
    });
  }

  /* Fisarmoniche della scheda d'acquisto. */
  function fisarmoniche(root){
    tutti('[data-km-acc]:not([data-km-ready])', root).forEach(function(a){
      a.setAttribute('data-km-ready','1');
      a.addEventListener('click', function(e){
        var b = e.target.closest && e.target.closest('[data-km-acc-btn]');
        if (!b) return;
        var aperto = b.getAttribute('aria-expanded') === 'true';
        var p = document.getElementById(b.getAttribute('aria-controls'));
        b.setAttribute('aria-expanded', aperto ? 'false' : 'true');
        if (p) p.hidden = aperto;
        var sg = uno('[data-km-acc-sign]', b);
        if (sg) sg.textContent = aperto ? '+' : '–';
      });
    });
  }

  /* Scheda d'acquisto: quantita, aggiunta al carrello con le ricariche, varianti. */
  function scheda(root){
    tutti('[data-km-pdp]:not([data-km-ready])', root).forEach(function(el){
      el.setAttribute('data-km-ready','1');

      var q = uno('[data-km-qty]', el);
      var meno = uno('[data-km-minus]', el);
      var piu  = uno('[data-km-plus]', el);
      if (meno && q) meno.addEventListener('click', function(){ q.value = Math.max(1, (parseInt(q.value,10)||1) - 1); });
      if (piu && q)  piu.addEventListener('click',  function(){ q.value = (parseInt(q.value,10)||1) + 1; });

      /* Aggiunta al carrello: un solo invio per il soffione e le ricariche spuntate.
         Se il tema non ha il carrello a scomparsa lasciamo fare l'invio normale. */
      var form = uno('.km-pdp__form', el);
      if (form) form.addEventListener('submit', function(ev){
        var cassetto = document.querySelector('cart-drawer');
        if (!cassetto || typeof cassetto.renderContents !== 'function') return;
        ev.preventDefault();

        var vid = uno('[data-km-vid]', el);
        if (!vid) return;
        var add = uno('[data-km-add]', el);
        var err = uno('[data-km-err]', el);
        var qta = uno('[data-km-qty]', el);

        var articoli = [{ id: Number(vid.value), quantity: Math.max(1, parseInt(qta && qta.value, 10) || 1) }];
        tutti('[data-km-addon]:checked', el).forEach(function(c){
          articoli.push({ id: Number(c.value), quantity: 1 });
        });

        if (err) err.hidden = true;
        if (add) { add.setAttribute('data-km-loading','1'); add.disabled = true; }

        function sblocca(){ if (add) { add.removeAttribute('data-km-loading'); add.disabled = false; } }
        function mostraErrore(testo){
          sblocca();
          if (err) { err.textContent = testo || 'Non siamo riusciti ad aggiungerlo. Riprova.'; err.hidden = false; }
        }

        fetch(radice() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
          body: JSON.stringify({
            items: articoli,
            sections: ['cart-drawer','cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        })
          .then(function(r){ return r.json(); })
          .then(function(j){
            if (j.status) { mostraErrore(j.description || j.message); return; }
            sblocca();
            tutti('[data-km-addon]:checked', el).forEach(function(c){ c.checked = false; });
            cassetto.renderContents(j);
          })
          .catch(function(){ mostraErrore('Qualcosa non ha funzionato. Riprova.'); });
      });

      var gruppi = tutti('[data-km-opt-group]', el);
      if (!gruppi.length) return;

      var varianti = [], prezzi = {};
      var vj = uno('[data-km-varianti]', el); if (vj) { try { varianti = JSON.parse(vj.textContent||'[]'); } catch(e){} }
      var pj = uno('[data-km-prezzi]', el);   if (pj) { try { prezzi   = JSON.parse(pj.textContent||'{}'); } catch(e){} }

      function aggiorna(){
        var scelte = [];
        gruppi.forEach(function(g){
          var r = uno('[data-km-opt]:checked', g);
          if (r) scelte.push(r.value);
          var out = uno('[data-km-opt-out]', g);
          if (out && r) out.textContent = r.value;
        });
        var v = null;
        for (var i = 0; i < varianti.length; i++){
          var ok = true;
          for (var k = 0; k < scelte.length; k++){
            if (String(varianti[i].options[k]) !== String(scelte[k])) { ok = false; break; }
          }
          if (ok) { v = varianti[i]; break; }
        }
        var add = uno('[data-km-add]', el);
        if (!v) { if (add) add.disabled = true; return; }

        var idIn = uno('[data-km-vid]', el);
        if (idIn) idIn.value = v.id;

        var info = prezzi[v.id] || {};
        var pz = uno('[data-km-price]', el);
        var ws = uno('[data-km-was]', el);
        if (pz && info.p) pz.innerHTML = info.p;
        if (ws) { if (info.c) { ws.innerHTML = info.c; ws.hidden = false; } else { ws.hidden = true; } }

        if (add) {
          add.disabled = !v.available;
          var lab = uno('[data-km-add-label]', add);
          if (lab) lab.textContent = v.available ? (add.getAttribute('data-label')||'') : (add.getAttribute('data-sold')||'');
        }
        if (window.history && history.replaceState) {
          try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); } catch(e){}
        }
      }
      tutti('[data-km-opt]', el).forEach(function(r){ r.addEventListener('change', aggiorna); });
    });
  }

  /* Confronto prima/dopo trascinabile, con carosello dei casi. */
  function primadopo(root){
    tutti('[data-km-ba]:not([data-km-ready])', root).forEach(function(el){
      el.setAttribute('data-km-ready','1');
      var casi = tutti('[data-km-case]', el);
      var cnt  = uno('[data-km-ba-count]', el);
      var i = 0;
      function vai(n){
        if (!casi.length) return;
        i = (n + casi.length) % casi.length;
        casi.forEach(function(c,k){ c.classList.toggle('is-on', k === i); });
        if (cnt) cnt.textContent = (i+1) + ' / ' + casi.length;
      }
      var pv = uno('[data-km-ba-prev]', el);
      var nx = uno('[data-km-ba-next]', el);
      if (pv) pv.addEventListener('click', function(){ vai(i-1); });
      if (nx) nx.addEventListener('click', function(){ vai(i+1); });

      tutti('[data-km-stage]', el).forEach(function(st){
        function posiziona(x){
          var r = st.getBoundingClientRect();
          var p = Math.min(100, Math.max(0, (x - r.left) / r.width * 100));
          st.style.setProperty('--km-x', p.toFixed(1) + '%');
        }
        var giu = false;
        st.addEventListener('pointerdown', function(e){ giu = true; try{ st.setPointerCapture(e.pointerId); }catch(err){} posiziona(e.clientX); });
        st.addEventListener('pointermove', function(e){ if (giu) posiziona(e.clientX); });
        st.addEventListener('pointerup',    function(){ giu = false; });
        st.addEventListener('pointercancel',function(){ giu = false; });
        st.addEventListener('keydown', function(e){
          var cur = parseFloat((st.style.getPropertyValue('--km-x') || '50').replace('%','')) || 50;
          if (e.key === 'ArrowLeft')  { st.style.setProperty('--km-x', Math.max(0, cur-5) + '%'); e.preventDefault(); }
          if (e.key === 'ArrowRight') { st.style.setProperty('--km-x', Math.min(100, cur+5) + '%'); e.preventDefault(); }
        });
      });
      vai(0);
    });
  }

  /* Barra fissa: compare quando il pulsante principale esce dallo schermo verso l'alto. */
  function barra(root){
    tutti('[data-km-sticky]:not([data-km-ready])', root).forEach(function(b){
      b.setAttribute('data-km-ready','1');
      var ancora = uno('[data-km-add]');
      if (!ancora || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function(voci){
        var v = voci[0];
        b.classList.toggle('is-on', !v.isIntersecting && v.boundingClientRect.top < 0);
      }, { threshold: 0 });
      io.observe(ancora);
      var btn = uno('[data-km-sticky-add]', b);
      if (btn) btn.addEventListener('click', function(){
        var f = uno('.km-pdp__form');
        if (!f) return;
        if (typeof f.requestSubmit === 'function') f.requestSubmit(); else f.submit();
      });
    });
  }

  function init(root){ galleria(root); fisarmoniche(root); scheda(root); primadopo(root); barra(root); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();